import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import IconDelete from 'assets/icons/delete-icon.svg'
import { selectedBackupApproverGroupsVar, setHasUnsavedChanges } from 'cache/manage-backup'

const DeleteHeaderRenderer: React.FC<any> = () => {
  const handleDeleteAll = () => {
    const current = selectedBackupApproverGroupsVar()

    const next = current
      .filter((row: any) => !row.isNewlyAdded)
      .map((row: any) => (row.isActive === false ? row : { ...row, isActive: false }))

    selectedBackupApproverGroupsVar(next)
    setHasUnsavedChanges(true)
  }

  return (
    <Tooltip title="Remove all assignments">
      <IconButton size="small" onClick={handleDeleteAll} color="error" data-testid="delete-all-btn">
        <img src={IconDelete} alt="Delete" style={{ width: '26px', height: '28px' }} />
      </IconButton>
    </Tooltip>
  )
}

export default DeleteHeaderRenderer
